export default __webpack_public_path__ + "static/media/bg-2.7cd86f63.jpg";